import CalculatorWidget from "./CalculatorWidget.svelte";
import BlockCalculatorWidget from "./BlockCalculatorWidget.svelte";
import NewBlockCalculatorWidget from "./NewBlockCalculatorWidget.svelte";



function createCalculatorWidget(params = {}) {
	if (!params.locale) {
		params.locale = ((window.settings && window.settings.locale) ? window.settings.locale : 'en-US');
	}
	return new CalculatorWidget({
		target: document.getElementById('calculator-widget-wrap'),
		props: params,
	});
}

function createBlockCalculatorWidget(target, params = {}) {
	if (!params.locale) {
		params.locale = ((window.settings && window.settings.locale) ? window.settings.locale : 'en-US');
	}
	return new BlockCalculatorWidget({
		target: target,
		props: params,
	});
}

function createNewBlockCalculatorWidget(target, params = {}) {
	if (!params.locale) {
		params.locale = ((window.settings && window.settings.locale) ? window.settings.locale : 'en-US');
	}
	return new NewBlockCalculatorWidget({
		target: target,
		props: params,
	});
}

window['createCalculatorWidget'] = createCalculatorWidget;
window['createBlockCalculatorWidget'] = createBlockCalculatorWidget;
window['createNewBlockCalculatorWidget'] = createNewBlockCalculatorWidget;